import React from "react";
import { PricingTiers } from "./sections/pricing/PricingTiers.js";
import type { ClientConfig } from "@repo/backend/schema/clientConfig";

interface PricingPageProps {
  clientId: string;
  config: ClientConfig;
}

export function PricingPage({ clientId, config }: PricingPageProps) {
  if (config.status === "active") {
    window.location.replace("/");
    return null;
  }

  return (
    <div style={{ minHeight: "100vh", background: "var(--color-background, #fff)" }}>
      <div
        style={{
          padding: "1.25rem 2rem",
          borderBottom: "1px solid color-mix(in srgb, var(--color-muted, #6b7280) 20%, transparent)",
        }}
      >
        <a
          href="/"
          style={{
            color: "var(--color-muted, #6b7280)",
            fontSize: "0.875rem",
            textDecoration: "none",
          }}
        >
          ← Back to preview
        </a>
      </div>
      <PricingTiers props={{}} clientId={clientId} />
    </div>
  );
}
